module.exports = __webpack_public_path__ + "img/symbol_0.c2323382.png";